const STORAGE_KEY = "vocabularium_library_reading";

export const LIBRARY_FONT_STEPS = [16, 18, 20, 22, 24];
export const LIBRARY_FONT_DEFAULT = 18;

function readStore() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function readLibraryPlace(bookId) {
  const place = readStore()[bookId];
  if (!place || typeof place !== "object") return null;
  const fontSize = LIBRARY_FONT_STEPS.includes(place.fontSize)
    ? place.fontSize
    : LIBRARY_FONT_DEFAULT;
  const anchor = String(place.anchor || "").trim();
  const percent = clampPercent(place.percent);
  return {
    fontSize,
    anchor,
    percent: percent == null ? 0 : percent,
    chapter: chapterIndex(place.chapter),
    chapterFraction: chapterFraction(place.chapterFraction),
  };
}

export function writeLibraryPlace(
  bookId,
  { anchor = "", fontSize = LIBRARY_FONT_DEFAULT, percent, chapter, chapterFraction: fraction } = {}
) {
  if (!bookId) return;
  const store = readStore();
  const previous = store[bookId] && typeof store[bookId] === "object" ? store[bookId] : {};
  const nextPercent = percent == null ? clampPercent(previous.percent) : clampPercent(percent);
  const next = {
    anchor: String(anchor || "").trim().slice(0, 120),
    fontSize: LIBRARY_FONT_STEPS.includes(fontSize) ? fontSize : LIBRARY_FONT_DEFAULT,
  };
  if (nextPercent != null) next.percent = nextPercent;
  const nextChapter = chapterIndex(chapter);
  if (nextChapter != null) {
    next.chapter = nextChapter;
    const nextFraction = chapterFraction(fraction);
    if (nextFraction != null) next.chapterFraction = nextFraction;
  }
  next.readAt = Date.now();
  store[bookId] = next;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // quota
  }
}

const FAVORITES_KEY = "vocabularium_library_favorites";

export function readLibraryFavorites() {
  try {
    const parsed = JSON.parse(localStorage.getItem(FAVORITES_KEY) || "[]");
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === "string" && id) : [];
  } catch {
    return [];
  }
}

export function toggleLibraryFavorite(bookId) {
  const ids = new Set(readLibraryFavorites());
  if (ids.has(bookId)) ids.delete(bookId);
  else ids.add(bookId);
  const next = [...ids];
  try {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
  } catch {
    // quota
  }
  return next;
}

export function latestInProgressBookId(bookIds) {
  const allowed = Array.isArray(bookIds) ? new Set(bookIds) : null;
  const store = readStore();
  let bestId = null;
  let bestAt = -1;
  Object.entries(store).forEach(([id, place]) => {
    if (!place || typeof place !== "object") return;
    if (allowed && !allowed.has(id)) return;
    const percent = clampPercent(place.percent);
    if (percent == null || percent <= 0 || percent >= 100) return;
    const at = Number(place.readAt) || 0;
    if (at < bestAt) return;
    bestAt = at;
    bestId = id;
  });
  return bestId;
}

function chapterIndex(value) {
  return Number.isInteger(value) && value >= 0 ? value : null;
}

function chapterFraction(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  return Math.round(Math.min(1, Math.max(0, value)) * 10000) / 10000;
}

function clampPercent(value) {
  const number = Math.round(Number(value));
  if (!Number.isFinite(number)) return null;
  return Math.min(100, Math.max(0, number));
}

export function stepLibraryFont(fontSize, direction) {
  const index = LIBRARY_FONT_STEPS.indexOf(fontSize);
  const current = index < 0 ? LIBRARY_FONT_STEPS.indexOf(LIBRARY_FONT_DEFAULT) : index;
  const next = Math.min(LIBRARY_FONT_STEPS.length - 1, Math.max(0, current + direction));
  return LIBRARY_FONT_STEPS[next];
}
